<form class="add-client page" [formGroup]="form">
  @if (!isLoading) {
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <div class="heading-wrapper">
    <h4>{{ 'pages.client.titleAdd' | translate }}</h4>
    <div class="actions d-flex">
      <button class="primary add-btn" type="button" (click)="submit()">
        {{ 'pages.client.submitAdd' | translate }}
      </button>
      <button class="secondary back-btn" type="button" (click)="back()">
        {{ 'pages.client.back' | translate }}
      </button>
    </div>
  </div>
  <div class="section">
    <div class="first-grid">
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="name">
            {{ 'pages.client.name' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip [marginBottom]="false" text="clientName" />
        </div>
        <input class="form-control lna" id="name" [ngClass]="{
              invalid: this.shouldRenderError('name') && name?.errors
            }" type="text" formControlName="name" name="name" required />
        <div class="error-wrapper">
          @if (this.shouldRenderError('name') && name?.errors) {
          @if (name?.errors?.['required']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          } @else if (name?.errors?.['minlength']) {
          <small class="error-message">
            {{
            'components.form.minLength'
            | translate
            : {
            name: name?.errors?.['minlength']['requiredLength']
            }
            }}
          </small>
          } @else if (name?.errors?.['maxlength']) {
          <small class="error-message">
            {{
            'components.form.maxLength'
            | translate
            : {
            maxLength: name?.errors?.['maxlength']['requiredLength']
            }
            }}
          </small>
          }
          }
        </div>
      </div>
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="surname">
            {{ 'pages.client.surname' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip [marginBottom]="false" text="clientSurname" />
        </div>
        <input class="form-control lna" id="surname" [ngClass]="{
              invalid: this.shouldRenderError('surname') && surname?.errors
            }" type="text" formControlName="surname" name="surname" required />
        <div class="error-wrapper">
          @if (this.shouldRenderError('surname') && surname?.errors) {
          @if (surname?.errors?.['required']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          } @else if (surname?.errors?.['minlength']) {
          <small class="error-message">
            {{
            'components.form.minLength'
            | translate
            : {
            name: name?.errors?.['minlength']['requiredLength']
            }
            }}
          </small>
          } @else if (surname?.errors?.['maxlength']) {
          <small class="error-message">
            {{
            'components.form.maxLength'
            | translate
            : {
            maxLength: name?.errors?.['maxlength']['requiredLength']
            }
            }}
          </small>
          }
          }
        </div>
      </div>
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="birthday">
            {{ 'pages.client.birthday' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <app-date-picker [date]="birthday?.value" [ngClass]="{
              invalid: this.shouldRenderError('birthdayme') && birthday?.errors
            }" [dateRangeMode]="dateRangeMode.Past" (dateSelected)="onDateSelected($event, 'birthday')" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('birthday') && birthday?.invalid) {
          @if (birthday?.errors?.['required']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          }
          }
        </div>
      </div>
      <div class="country-wrapper">
        <div class="label-wrapper">
          <label class="form-label lna" for="countryId">
            {{ 'pages.client.country' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip [marginBottom]="false" text="clientCountry" />
        </div>
        <select id="countryId" [ngClass]="{
              invalid: this.shouldRenderError('countryId') && countryId?.invalid && (countryId?.touched || submitAttempted)
            }" (blur)="onCountryBlur()" formControlName="countryId">
          <option class="empty-option" [value]="-1" [selected]="true" disabled>
            {{ 'pages.client.chooseCountry' | translate }}
          </option>
          @for (country of countries; track country.id) {
          <option [value]="country.id">{{ country.name }}</option>
          }
        </select>
        <div class="error-wrapper">
          @if (this.shouldRenderError('countryId') && countryId?.invalid) {
          @if (countryId?.errors?.['min']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          }
          }
        </div>
      </div>

    </div>
    <div class="first-grid first-grid-2">
            <div>
              <div>
                <div class="label-wrapper">
                  <label class="form-label lna" for="officialDocumentId">
                    {{ 'pages.client.officialDocumentId' | translate }}
                    @if (isIdVerifiedInPerson?.value) {
                    <span class="required-field">*</span>
                    }
                  </label>
                  <app-tooltip [marginBottom]="false" text="officialDocumentId" />
                </div>
                <input class="form-control lna" id="officialDocumentId" [ngClass]="{
                                                            invalid: this.shouldRenderError('officialDocumentId') && officialDocumentId?.errors
                                                          }" type="text" [maxlength]="50" formControlName="officialDocumentId"
                  name="officialDocumentId" />
                <div class="error-wrapper">
                  @if (isIdVerifiedInPerson?.value && this.shouldRenderError('officialDocumentId') &&
                  officialDocumentId?.errors) {
                  @if (officialDocumentId?.errors?.['required']) {
                  <small class="error-message">
                    {{ 'components.form.errorRequired' | translate }}
                  </small>
                  }
                  }
                </div>
              </div>
            </div>
      <div class="in-person-id-wrapper">
        <div class="label-wrapper">
          <label class="form-label lna" for="isIdVerifiedInPerson">
            {{ 'pages.client.isIdVerifiedInPerson' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip [marginBottom]="false" text="clientIsIdVerifiedInPerson" />
        </div>
        <div class="in-person-id">
          <div class="radio-wrapper">
            <input id="yes" [value]="true" type="radio" formControlName="isIdVerifiedInPerson" />
            <label for="active">{{ 'pages.client.yes' | translate }}</label>
          </div>
          <div class="radio-wrapper">
            <input id="no" [value]="false" type="radio" formControlName="isIdVerifiedInPerson" />
            <label for="inactive">{{ 'pages.client.no' | translate }}</label>
          </div>
          @if (this.shouldRenderError('isIdVerifiedInPerson') && isIdVerifiedInPerson?.invalid) {
          @if (isIdVerifiedInPerson?.errors?.['required']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          }
          }
        </div>
      </div>
      @if (isIdVerifiedInPerson?.value) {
      <div class="value-wrapper">
        <p class="form-label lna">
          {{ 'pages.client.general.verifiedByUser' | translate }}
        </p>
        <p class="form-value">{{ verifierFullName?.value || '-' }}</p>
      </div>
      }
    </div>
    <div class="first-grid">
    </div>
    <div class="second-grid second-grid-auth">
      <div class="planned-auth-type-wrapper">
        <div class="label-wrapper">
          <label class="form-label lna" for="plannedAuthType">
            {{ 'pages.client.plannedAuthType' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-tooltip text="plannedAuthTypeBackoffice" [marginBottom]="false"/>
        </div>
        <div class="in-person-id">
          <div class="radio-wrapper">
            <input type="radio" id="plannedAuthType-latviaLv" name="plannedAuthType" formControlName="plannedAuthType"
              [value]="'latviaLv'" />
            <label for="plannedAuthType-latviaLv">
              {{ 'pages.client.latviaLvAuth' | translate }}
            </label>
          </div>

          <div class="radio-wrapper">
            <input type="radio" id="plannedAuthType-email" name="plannedAuthType" formControlName="plannedAuthType"
              [value]="'email'" />
            <label for="plannedAuthType-email">
              {{ 'pages.client.emailAuth' | translate }}
            </label>
          </div>

          <div class="radio-wrapper">
            <input type="radio" id="plannedAuthType-unknown" name="plannedAuthType" formControlName="plannedAuthType"
              [value]="'unknown'" />
            <label for="plannedAuthType-unknown">
              {{ 'pages.client.unknownlAuth' | translate }}
            </label>
          </div>

          <div class="error-wrapper">
            @if (this.shouldRenderError('plannedAuthType') && plannedAuthType?.errors?.['required']) {
            <small id="plannedAuthTypeError" class="error-message">
              {{ 'components.form.errorRequired' | translate }}
            </small>
            }
          </div>
        </div>
      </div>
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="nationalDigitalId">
            {{ 'pages.client.nationalDigitalId' | translate }}
            @if (plannedAuthType?.value === 'latviaLv'){
            <span class="required-field">*</span>
            }
          </label>
          <app-tooltip [marginBottom]="false" text="nationalDigitalId" />
        </div>
        @if (plannedAuthType?.value === 'latviaLv'){
                  <input [readOnly]="plannedAuthType?.value === 'email' || plannedAuthType?.value === 'unknown'" class="form-control lna" id="nationalDigitalId"
          [ngClass]="{
                            invalid: this.shouldRenderError('nationalDigitalId') && nationalDigitalId?.errors
                          }" type="text" pattern="[0-9-]*" [minlength]="11" [maxlength]="12"
          [disabled]="plannedAuthType?.value === 'email' || plannedAuthType?.value === 'unknown'" formControlName="nationalDigitalId"
          (keypress)="allowOnlyNumbersAndSingleDash($event)" (input)="validateSingleDash($event)"
          name="nationalDigitalId">
        <div class="error-wrapper">
          @if (this.shouldRenderError('nationalDigitalId') && nationalDigitalId?.invalid) {
          @if (name?.errors?.['required']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          } @else if (nationalDigitalId?.errors?.['minlength']) {
          <small class="error-message">
            {{ 'components.form.minLength' | translate : { minLength: 11 } }}
          </small>
          }
          }
        </div>
        } @else {
          <p>-</p>
        }

      </div>
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="authEmail">
            {{ 'pages.client.authEmail' | translate }}
          </label>
                      @if (plannedAuthType?.value === 'email'){
                      <span class="required-field">*</span>
                      }
          <app-tooltip [marginBottom]="false" text="clientAuthEmail" />
        </div>
        @if (plannedAuthType?.value === 'email'){
        <input class="form-control lna" id="authEmail" [ngClass]="{
                          invalid: this.shouldRenderError('authEmail') && authEmail?.errors
                        }" type="text" formControlName="authEmail" name="authEmail" [readOnly]="plannedAuthType?.value === 'latviaLv' || plannedAuthType?.value === 'unknown'"
                        [disabled]="plannedAuthType?.value === 'latviaLv' || plannedAuthType?.value === 'unknown'">
        <div class="error-wrapper">
          @if (this.shouldRenderError('authEmail') && authEmail?.errors) {
          @if (name?.errors?.['required']) {
          <small class="error-message">
            {{ 'components.form.errorRequired' | translate }}
          </small>
          } @else if (authEmail?.errors?.['invalidEmail']) {
          <small class="error-message">
            {{ 'components.form.invalidEmail' | translate }}
          </small>
          } @else if (authEmail?.errors?.['minlength']) {
          <small class="error-message">
            {{
            'components.form.minLength'
            | translate
            : {
            minLength: authEmail?.errors?.['minlength']['requiredLength']
            }
            }}
          </small>
          } @else if (authEmail?.errors?.['maxlength']) {
          <small class="error-message">
            {{
            'components.form.maxLength'
            | translate
            : {
            maxLength: authEmail?.errors?.['maxlength']['requiredLength']
            }
            }}
          </small>
          }
          }
        </div>
      } @else {
        <p>-</p>
      }
      </div>
    </div>
    <div class="second-grid">
      <div class="title-row">
        <h3>{{ 'pages.client.contactInfoTitle' | translate }}</h3>
        <app-tooltip [marginBottom]="false" text="clientContactInfo" />
      </div>
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="email">
            {{ 'pages.client.email' | translate }}
          </label>
          <app-tooltip [marginBottom]="false" text="clientEmail" />
        </div>
        <input class="form-control lna" id="email" [ngClass]="{
              invalid: this.shouldRenderError('email') && email?.errors
            }" type="text" formControlName="email" name="email" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('email') && email?.errors) {
          @if (email?.errors?.['invalidEmail']) {
          <small class="error-message">
            {{ 'components.form.invalidEmail' | translate }}
          </small>
          } @else if (email?.errors?.['minlength']) {
          <small class="error-message">
            {{
            'components.form.minLength'
            | translate
            : {
            minLength: email?.errors?.['minlength']['requiredLength']
            }
            }}
          </small>
          } @else if (email?.errors?.['maxlength']) {
          <small class="error-message">
            {{
            'components.form.maxLength'
            | translate
            : {
            maxLength: email?.errors?.['maxlength']['requiredLength']
            }
            }}
          </small>
          }
          }
        </div>
      </div>
      <div>
        <div class="label-wrapper">
          <label class="form-label lna" for="phone">
            {{ 'pages.client.phone' | translate }}
            <span class="required-field"></span>
          </label>
          <app-tooltip [marginBottom]="false" text="clientPhone" />
        </div>
        <input class="form-control lna" id="phone" [ngClass]="{
              invalid: this.shouldRenderError('phone') && phone?.errors
            }" type="text" formControlName="phone" name="phone" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('phone') && phone?.errors) {
          @if (phone?.errors?.['invalidPhone']) {
          <small class="error-message">
            {{ 'components.form.invalidPhone' | translate }}
          </small>
          } @else if (phone?.errors?.['minlength']) {
          <small class="error-message">
            {{
            'components.form.minLength'
            | translate
            : {
            minLength: phone?.errors?.['minlength']['requiredLength']
            }
            }}
          </small>
          } @else if (phone?.errors?.['maxlength']) {
          <small class="error-message">
            {{
            'components.form.maxLength'
            | translate
            : {
            maxLength: phone?.errors?.['maxlength']['requiredLength']
            }
            }}
          </small>
          }
          }
        </div>
      </div>
      <div></div>
      <div class="address-wrapper">
        <div class="label-wrapper">
          <label class="form-label lna" for="address">
            {{ 'pages.client.address' | translate }}
            <span class="required-field"></span>
          </label>
          <app-tooltip [marginBottom]="false" text="clientAddress" />
        </div>
        <input class="form-control lna" id="address" [ngClass]="{
              invalid: this.shouldRenderError('address') && address?.errors
            }" type="text" formControlName="address" name="address" />
        <div class="error-wrapper">
          @if (this.shouldRenderError('address') && address?.errors) {
          @if (address?.errors?.['minlength']) {
          <small class="error-message">
            {{
            'components.form.minLength'
            | translate
            : {
            minLength: address?.errors?.['minlength']['requiredLength']
            }
            }}
          </small>
          } @else if (address?.errors?.['maxlength']) {
          <small class="error-message">
            {{
            'components.form.maxLength'
            | translate
            : {
            maxLength: address?.errors?.['maxlength']['requiredLength']
            }
            }}
          </small>
          }
          }
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="fullscreen-loader">
    <app-spinner [isLoading]="isLoading" />
  </div>
  }
</form>
